import axios from '@/libs/api.request'
const user = {
    // 用户登录
    login: (data) => {
        return axios.post({
            url: '/User/Login',
            data: data
        })
    }
}
export default user


// WEBPACK FOOTER //
// ./src/api/api-user.js